/* Built In Imports */
import { useState } from 'react';

/* External Imports */
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, FormControl, Image, Text } from '@chakra-ui/react';
import { AiOutlineCheckCircle, AiOutlinePlusCircle } from 'react-icons/ai';

/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import config from '@config';

/**
 *
 * @param card
 * @param activeCardCount
 * @param setActiveCardCount
 */

const NewsLetterCard = ({
  card,
  activeCardCount,
  updateCount,
  sectionContent,
  region,
  updateSelItems
}) => {
  const [lang, setLang] = useState('en');
  const lngList = config.lngList;  
  const [isOpen, setIsOpen] = useState(false);

  const cardHandler = () => {
    if (lang) {
      if (card.isSelected) {
        updateCount(activeCardCount - 1);
      } else {
        updateCount(activeCardCount + 1);
      }
      updateSelItems(
        card.isSelected,
        lang,
        card.languageAndNewsletterIdentifier[0]?.data[lang],
        ''
      );
      card.isSelected = !card.isSelected;
    }
  };

  const selectLang = (loc) => {
    setLang(loc);
    if (card.isSelected) {
      updateSelItems(
        card.isSelected,
        loc,
        card.languageAndNewsletterIdentifier[0]?.data[loc],
        'upd'
      );
    }
    setIsOpen(false);
  };

  return (
    <Box
      h="449px"
      maxH="449px"
      className="card"
      width={{ base: '321px', md: '370px' }}
      boxShadow="0 0 7px rgba(0, 0, 0, 0.304857)"
      m="20px 13px"
      p="0 0 20px 0"
    >
      <Box height={{ base: '189.13px', md: '218px' }}>
        <Image
          src={card.thumbnail?.url}
          alt={card.thumbnail?.alt}        
          maxHeight={{ base: '189.13px', md: '218px' }}
          minHeight={{ base: '189.13px', md: '218px' }}
          width="100%"
          // objectFit="cover"
          margin="0"
          padding="0"
          clipPath="polygon(0 0, 100% 0, 100% 91%, 0% 100%)"
      />
      </Box>
      
      <Box p="0 26px 25px 29px">
        <Flex
          alignItems="flex-end"
          width="100%"
          h="auto"
          justifyContent="flex-end"
          mb={{ base: '12px', md: '10.22px' }}
        >
          {card.tags?.split(',')?.map((tag, key) => {
            return (
              <Button
                key={key}
                variant="ghost"
                rounded="full"
                fontSize="14px"
                lineHeight="16px"
                color="#676055"
                fontFamily="FedraSansStd-Book"
                padding="5px 10px"
                maxHeight="28px"
                fontWeight={400}
                marginLeft="16px"
                cursor="auto"
                _active={{
                  bgColor: 'none',
                }}
                _hover={{
                  bgColor: 'none',
                }}
              >
                {tag}
              </Button>
            );
          })}
        </Flex>
        <Box mt="20px">
          <Text
            as="h3"
            fontFamily="'FedraSansStd-A-medium', serif"
            fontStyle="normal"
            fontWeight="500"
            fontSize={{ base: '22px', md: '24px' }}
            lineHeight={{ base: '23px', md: '27px' }}
            /* or 112% */
            mb={{ base: '8px', md: '10px' }}
            color="#28231E"
          >
            {card.title}
          </Text>
          <Text
            as="p"
            fontFamily="FedraSansStd-Book"
            fontStyle="normal"
            fontWeight="400"
            fontSize="16px"
            minH="72px"
            lineHeight={{ base: '23px', md: '24px' }}
            /* or 150% */
            mb={{ base: '26px', md: '20px' }}
            color="#676055"
          >
            {StructuredTextContent(card?.description)}
          </Text>
          <Flex
            justifyContent="space-between"
            alignItems="center"
            w="100%"
            height="auto"
          >
            <FormControl>              
              {Object.keys(card.languageAndNewsletterIdentifier[0]?.data)?.length > 1 && (
                <>
                  <Button
                    bg="#ffffff"
                    border="none"
                    borderRadius="0"
                    borderBottom="1px solid #D8D8D8"
                    color="#000000"
                    minW={{ base: '105px', md: '105px' }}
                    maxH={{ base: '20px', md: '20px' }}
                    _hover={{ borderBottom: '1px solid #D8D8D8' }}
                    _focus={{ borderBottom: '1px solid #D8D8D8' }}
                    _active={{ borderBottom: '1px solid #D8D8D8' }}
                    rightIcon={<ChevronDownIcon />}
                    onClick={() => setIsOpen(!isOpen)}
                    onBlur={() => setIsOpen(false)}
                    // onMouseOut={() => setIsOpen(false)}
                    // onMouseEnter={() => setIsOpen(true)}
                    p="1.5rem 0 1rem 0"
                  >
                    <Flex alignItems="flex-start" w="100%">
                      <Text textAlign="left" fontWeight="400" fontFamily="FedraSansStd-Book">{lngList[lang]}</Text>
                    </Flex>
                    {isOpen && (
                      <Flex
                        _before={{ content: "''", height: '17px' }}
                        _after={{ content: "''", height: '17px' }}
                        display={isOpen ? 'block' : 'none'}
                        _hover={{ display: isOpen ? 'block' : 'none' }}
                        className="options"
                        onMouseLeave={() => {
                          setIsOpen(false);
                        }}
                        onClick={() => setIsOpen(false)}
                        // onBlur={() => setIsOpen(false)}
                        // onClick={() => setIsOpen(false)}
                        position="absolute"
                        top="37px"
                        border="0"
                        zIndex="10"
                        left="0"
                        borderRadius="0"
                        flexDir="column"
                        bg="#ffffff"
                        mt="8px"
                        w="105px"
                        fontSize="16px"
                        boxShadow="0 4px 4px rgba(0, 0, 0, 0.25)"
                      >
                        {Object.keys(
                          card.languageAndNewsletterIdentifier[0]?.data
                        )?.map((item, index) => {
                          return (
                            <Box
                              padding="9px 0 9px 11px"
                              textAlign=" left"
                              fontWeight="400"
                              key={index}
                              onClick={() => { selectLang(item) }}
                              cursor="pointer"
                            >
                              <Text
                                color="#000000"
                                _hover={{ color: '#A33A2C', fontWeight: '600' }}
                                fontFamily="FedraSansStd-book"
                              >
                                {lngList[item]}
                              </Text>
                            </Box>
                          );
                        })}
                      </Flex>
                    )}
                  </Button>                  
                </>
              )}
            </FormControl>
            
            <style>
              {`
              #ddlSelect {
                width: 105px;
                border: 0;
                border-bottom: 1px solid #d8d8d8 !important;
                color: #000000;
                outline: 0;
                padding:0 !important;
              }
              #ddlSelect + .css-zj2dqk{
                right: -5px !important;
              }
              #ddlSelect div {
                border: 0 !important;
                font-size: 16px;
                padding: 0;
                outline: 0;
              }
            .option {
              padding-left: 5px !important;
              margin-left:5px !important;
              font-size:16px;
              line-height:20px;
            }
            .option::before{
              content:"";
              width:10px;
              height:100%;
              
            }
            .select {
              border: 0;
              font-weight: 400;
              font-size: 16px;
              line-height: 20px;
              border-bottom: 1px solid #d8d8d8;
              width: 89px;
            }
          `}
            </style>

            <Button
              leftIcon={
                card.isSelected ? (
                  <AiOutlineCheckCircle />
                ) : (
                  <AiOutlinePlusCircle />
                )
              }
              rounded="md"
              variant={card.isSelected ? 'solid' : 'outline'}
              outline="0.8px solid #CF4520"
              color={card.isSelected ? '#ffffff' : '#CF4520'}
              border={0}
              borderRadius="3px"
              maxH="32px"
              _hover={{ border: 'none' }}
              m={0}
              fontWeight="400"
              fontSize="16px"
              fontFamily="FedraSansStd-Book"
              lineHeight="20px"
              onClick={e => cardHandler()}
              p="10px 30px"
            >
              {card.isSelected
                ? sectionContent?.content?.json?.cardButtonTextSelected
                : sectionContent?.content?.json?.cardButtonText}
            </Button>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

export default NewsLetterCard;
